/**
 * Created with IntelliJ IDEA.
 * User: dkoehler
 * Date: 31.10.12
 * Time: 10:22
 * To change this template use File | Settings | File Templates.
 */

export class CachebreakerInfoObject {
    public fileSize: number;
    public loadingStartTime: number;
    public loadingEndTime: number;
    public originURL: string;
}
